import classNames from 'classnames';
import React from 'react';
import styles from './CartBottomMessage.module.scss';
import { useRecoilValue } from 'recoil';
import { appliedDiscountCodeState, shopifyState } from '../../recoil/atoms';

interface Props {
  hasFinalSaleItems: boolean;
}
export const CartBottomMessage: React.FC<Props> = ({ hasFinalSaleItems }) => {
  const appliedDiscountCode = useRecoilValue(appliedDiscountCodeState);
  const className = classNames(styles.hlCartBottom);
  const shopify = useRecoilValue(shopifyState);
  const isUSD = shopify?.currency.active === 'USD';
  const showReturnsMessage = isUSD && !appliedDiscountCode;

  return hasFinalSaleItems ? (
    <div className={className}>Final Sale Items may not be returned.</div>
  ) : showReturnsMessage ? (
    <div className={className}>Free returns and exchanges</div>
  ) : (
    <React.Fragment />
  );
};

export default CartBottomMessage;
